import { useDependencies } from '@servicetitan/react-ioc';
import { useMutation } from '@tanstack/react-query';
import {
    ExternalApplicationRequest,
    ExternalApplicationResponse,
    FinancingApi,
} from '@servicetitan/financing-api-client';
import { openWebUrl } from '@servicetitan/financing-utils-shared';
import { SetupDataStore } from '@servicetitan/financing-workflow-shared';

/**
 * Submits an Affirm prequalification directly to the backend and, on success, opens the returned
 * Affirm-hosted (Parallel) URL. The applicant's name is resolved upstream from the customer, so no
 * intermediate customer-info dialog is required before starting the Affirm flow.
 */
export const useAffirmPrequalification = () => {
    const [financingApi] = useDependencies(FinancingApi);
    const { setupData } = SetupDataStore.useStore();

    return useMutation({
        mutationKey: ['affirmPrequalification'],
        mutationFn: (request: ExternalApplicationRequest) =>
            financingApi.loansSubmitExternalApplication(request),
        onSuccess: ({ data }: { data: ExternalApplicationResponse }) => {
            const linkToOpen = data?.accessLink ?? data?.redirectLink;
            if (linkToOpen) {
                openWebUrl(linkToOpen, setupData?.useInAppBrowser);
            }
        },
    });
};
